import React from 'react';
import AddRecipeForm from "../components/form/Form";

export default function AddRecipePage() {
    return(
        <AddRecipeForm/>
    );

}
